import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Footer } from "@/components/Footer";

export const PrivacyPage = () => {
  const { t, lang, setLang } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="privacy-page">
      <header className="sticky top-0 z-50 border-b border-line bg-cream/80 backdrop-blur-xl">
        <div className="max-w-4xl mx-auto px-6 h-[72px] flex items-center justify-between">
          <Link to="/" data-testid="privacy-logo-link" className="font-serif text-3xl font-medium tracking-tight text-ink">
            FILIA<span className="text-terra">.</span>
          </Link>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1 border border-line rounded-full p-1" data-testid="privacy-lang-switcher">
              {["it", "en"].map((l) => (
                <button
                  key={l}
                  data-testid={`privacy-lang-${l}`}
                  onClick={() => setLang(l)}
                  className={`px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide transition-colors duration-200 ${
                    lang === l ? "bg-terra text-cream" : "text-inksoft hover:text-ink"
                  }`}
                >
                  {l}
                </button>
              ))}
            </div>
            <Link
              to="/"
              data-testid="privacy-back-link"
              className="hidden sm:inline-flex items-center gap-2 text-sm font-semibold text-inksoft hover:text-terra transition-colors duration-200"
            >
              <ArrowLeft size={16} strokeWidth={2} />
              {t.privacy.back}
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16 lg:py-24">
        <h1 className="font-serif font-medium tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl">
          {t.privacy.title}
        </h1>
        <p data-testid="privacy-updated" className="mt-4 text-sm text-inksoft">{t.privacy.updated}</p>

        <div className="mt-14 space-y-12">
          {t.privacy.sections.map((s, i) => (
            <section key={i} data-testid={`privacy-section-${i}`} className="border-t border-line pt-8">
              <h2 className="font-serif text-2xl lg:text-3xl font-medium text-ink">{s.title}</h2>
              <p className="mt-4 text-base md:text-lg leading-relaxed text-inksoft">{s.text}</p>
            </section>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
};
